import { HttpClient,HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { CreateDevice, SearchDevices, UpdateDevice } from "../models/device";


@Injectable({
    providedIn:'root'
})

export class DevicesService{

    user: string;
    userName: string;

    constructor(private http:HttpClient){
        this.user = sessionStorage.getItem('user');
        this.userName = JSON.parse(this.user)?.username;
    }

    /**
   * Method to create a new device.
   * @param device
   */
    create(device: CreateDevice) {
        const sessionId = localStorage.getItem('sessionId');
        const headers = new HttpHeaders().set('cookie-header' , `${sessionId}:${this.userName}`);
        const url = `${environment.apiURL}/admin/devices/create`;
        return this.http.post<CreateDevice>(url, device, {headers});
    }

        /**
   * Method to get data of a device.
   * @param device_token
   */
    get(device_token: any) {
        const url = `${environment.apiURL}/admin/devices/get?device_token=${device_token}`;
        const sessionId = localStorage.getItem('sessionId');
        const headers = new HttpHeaders().set('cookie-header' , `${sessionId}:${this.userName}`);
        return this.http.get<CreateDevice>(url, {headers});
    }

    /**
   * Method to update data of a device.
   * @param deviceToken
   * @param updates
   */
    update(deviceToken: number, updates?: any) {
        const url = `${environment.apiURL}/admin/devices/update?device_token=${deviceToken}`;
        const sessionId = localStorage.getItem('sessionId');
        const headers = new HttpHeaders().set('cookie-header' , `${sessionId}:${this.userName}`);
        return this.http.put<UpdateDevice>(url,  updates, {headers} );
    }

    /**
   * Method to delete a device.
   * @param deviceID
   */
    deleteDevice(deviceID:string){
        const sessionId = localStorage.getItem('sessionId');
        const headers = new HttpHeaders().set('cookie-header' , `${sessionId}:${this.userName}`);
        const url = `${environment.apiURL}/admin/devices/delete?device_token=${deviceID}`;
        return this.http.delete(url, {headers});
    }

    /**
    * Method to search or sort  devices.
    * @param payload
    */
    search(payload: SearchDevices) {
        const sessionId = localStorage.getItem('sessionId');
        const url = `${environment.apiURL}/admin/devices/search`;
        const headers = new HttpHeaders().set('cookie-header' , `${sessionId}:${this.userName}`);
        return this.http.post<{}>(url, payload , { headers });
    }

    getUserAssociateDevices(lms_user_id:string) {
        const user = sessionStorage.getItem('user');
        const userName = JSON.parse(user).username;
        const sessionId = localStorage.getItem('sessionId');
        const url = `${environment.apiURL}/admin/devices/get-associated-devices`;
        return this.http.get(url, {params: {lms_user_id},
            headers: { 'cookie-header': `${sessionId}:${userName}`}
        }, 
    );
    }

}

//const sessionId = localStorage.getItem('sessionId');
//const headers = new HttpHeaders().set('cookie-header' , `${sessionId}:${this.userName}`);